module.exports = __webpack_public_path__ + "files/d6682fcf5605d5920e37adc7b8d74168.svg";